import { useCallback } from 'react';
import { useLocale } from './use-locale';
import { translate as translateHelper } from './translate';
import { LOCALES } from './locales';
import { LocaleArgument } from './types';

export const useTranslation = () => {
    const locale = useLocale();

    const translate = useCallback(
        (key: keyof typeof LOCALES, args?: LocaleArgument) => translateHelper(key, locale, LOCALES, args),
        [locale]
    );

    return { translate, locale };
};
